// extracted by mini-css-extract-plugin
export var MatrixInput = "matrix-input-module--MatrixInput--e2ac6";
export var label = "matrix-input-module--label--ca0ed";
export var table = "matrix-input-module--table--75cbe";